<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-demo app-breadcrumb"
    mode="horizontal"
    style="display: flex"
  >
    <img :src="login_center_bg" class="login-center-img" />
    <el-menu-item
      style="
        width: auto;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
		margin-right:10px;
        color: inherit;
      "
      :index="item.index1"
      v-for="item in levelList"
      :key="item.index"
      ><router-link
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
        ><span v-if="languageType == 0">{{ item.meta.title }}</span>
        <span v-if="languageType == 1">{{
          item.meta.title1
        }}</span></router-link
      ></el-menu-item
    >
  </el-menu>
</template>

<script>
import { getCookie } from "@/utils/support";
import languageData from "@/utils/language.json";
import { mapGetters } from "vuex";
import login_center_bg from "@/assets/images/scrollLogo.png";
export default {
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    routes() {
      // return this.$router.options.routes
      return this.routers;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: [],
      // 语言类型
      languageType: getCookie("language"),
      languageData,
      activeIndex: 2,
      login_center_bg,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    getBreadcrumb() {
      var route_name = this.$route.name;
      this.levelList = [];
      this.$router.options.routes.forEach((element, index) => {
        if (element.children) {
          if (route_name == element.children[0].name) {
            this.activeIndex = "'"+index+"'";
          }
          element.index = index;
          element.index1 = "'"+index+"'";
          this.levelList.push(element);
        }
      });
      let matched = this.$route.matched.filter((item) => item.name);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb {
  font-size: 18px;
  margin-left: -37px;
  width: 860px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
.login-center-img {
  width: auto;
  height: 28px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue